import React from "react";
import { Box, Typography } from "@mui/material";
import useSharedStyles from "../styles/Shared";

type FormStickyHeaderProps = {
  children: React.ReactNode;
};

const FormStickyHeader: React.FC<FormStickyHeaderProps> = ({ children }) => {
  const { classes: sharedClasses } = useSharedStyles();
  return (
    <Box className={sharedClasses.stickyHeader}>
      <Typography variant="h1" pb={0}>
        {children}
      </Typography>
    </Box>
  );
};

export default FormStickyHeader;
